import React, { FC, PropsWithChildren } from 'react';
import { FadeInElement } from '@components/animations/FadeInElement/FadeInElement.component';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Modal } from '@layout/components/Modal/Modal.component';
import { StyledModal } from '@layout/components/Modal/StyledModal.component';
import { ModalProps } from './Modal.types';

interface Props extends Omit<ModalProps, 'actions'> {
  displayButton: boolean;
  onValidation: () => void;
  isJournalPage?: boolean;
}

export const ValidationModal: FC<PropsWithChildren<Props>> = ({
  isJournalPage = false,
  displayButton,
  onValidation,
  children,
  ...rest
}) => {
  return isJournalPage ? (
    <StyledModal
      actions={
        <FadeInElement className="submit-button-wrapper" show={displayButton} style={{ width: '100%' }}>
          <PrimaryButton
            isDarkGreen
            onClick={onValidation}
            style={{ width: '100%' }}
            textProps={{ i18nKey: 'common.validate' }}
            type="submit"
          />
        </FadeInElement>
      }
      {...rest}
    >
      {children}
    </StyledModal>
  ) : (
    <Modal
      actions={
        <FadeInElement className="submit-button-wrapper" show={displayButton}>
          <PrimaryButton onClick={onValidation} textProps={{ i18nKey: 'common.validate' }} type="submit" />
        </FadeInElement>
      }
      {...rest}
    >
      {children}
    </Modal>
  );
};
